module.exports = __webpack_public_path__ + "static/media/access-log.d6a7645c.png";